import http from './reddit'
// generalledger
export default {
    getsitelist: () => http.Get(`${http.url.Newcommon}/getsitelist`),    //拉取各站點
    linkreporta1: ({ stidlist, gmclist, stdate, endate, iscal }) => http.Get(`${http.url.Newcommon}/linkreporta1?stidlist=${stidlist}&gmclist=${gmclist}&stdate=${stdate}&endate=${endate}&iscal=${iscal}`), //總帳第一層
    linkreporta2_9: ({ repnum, stid, gmclist, stdate, endate, iscal, mid, seekdate }) => {
        let seek = repnum == 9 ? `&seekdate=${seekdate}` : ''
        let str = `${http.url.Newcommon}/linkreporta2_9?repnum=${repnum}&stid=${stid}&gmclist=${gmclist}&stdate=${stdate}&endate=${endate}&iscal=${iscal}&mid=${mid}` + seek
        return http.Get(str)
    },  //總帳第2-9層
    linkrepuplv: ({ stdate, endate, stid, mid }) => http.Get(`${http.url.Newcommon}/linkrepuplv?stdate=${stdate}&endate=${endate}&stid=${stid}&mid=${mid}`), // 报表上方阶层表
    reportdate2: (gameid, btn = 0) => http.Get(`${http.url.six}/reportdate2/${gameid}/${btn}`),//总帐＆分类帐选单
    repair: (repstdate = '', rependate = '', category = '') => http.Get(`${http.url.Newcommon}/reporta0/${repstdate}/${rependate}/${category}/0`),    //总帐-上丢补货
    repairDate: (repstdate = '', rependate = '', mid = '') => http.Get(`${http.url.Newcommon}/reporta0/${repstdate}/${rependate}/3/${mid}`),    //总帐-上丢补货日期层
    repairResult: (repstdate = '', rependate = '', date = '', mid = '') => http.Get(`${http.url.Newcommon}/reporta14/${repstdate}/${rependate}/${date}/${mid}`),    //总帐-上丢补货分类帐最底层

    // cq9注单明细
    linkorderdetail_cq9: (data) => http.Post(`${http.url.Newcommon}/linkorderdetail_cq9`, data),
    // 报表查询 取得指定站点的会员帐号的id
    GetMemberNumberForSite: (data) => http.Post(`${http.url.Newcommon}/linkgetmemmid`, data),
}